import type { TourConfig, TourStep } from './types';

/** Central registry of all available tours */
const tours = new Map<string, TourConfig>();

export function registerTour(tour: TourConfig) {
  tours.set(tour.id, tour);
}

export function getTour(id: string): TourConfig | undefined {
  return tours.get(id);
}

export function getAllTours(): TourConfig[] {
  return [...tours.values()];
}

export function getToursByRole(role: string): TourConfig[] {
  return [...tours.values()].filter((t) => !t.roles || t.roles.includes(role));
}

export function getToursByProduct(slug: string): TourConfig[] {
  return [...tours.values()].filter((t) => t.productSlug === slug);
}

/**
 * Return the steps for a tour that the current user is allowed to see.
 * A step with no featureKey is always included. A step with featureKey (string
 * or string[]) is included when can() returns true for at least one of the keys.
 */
export function getFilteredSteps(tourId: string, can: (key: string) => boolean): TourStep[] {
  const tour = tours.get(tourId);
  if (!tour) {
    return [];
  }
  return tour.steps.filter((step) => {
    if (!step.featureKey) {
      return true;
    }
    const keys = Array.isArray(step.featureKey) ? step.featureKey : [step.featureKey];
    return keys.some(can);
  });
}
